import React from "react";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as mem from "./recopieLotFournisseur";
import * as intchaine from "./interface-chaine";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { ImSpinner3 } from "react-icons/im";
import "./App.css";
import {DEBUG} from "./utilitaires";

export default function ModalCreationLot(props) {
  //pour le modal qui montrera tout le lot
  const [showCreation, setShowCreation] = useState(props.montrer);
  const handleShowCreation = () => setShowCreation(true);
  const handleCloseCreation = () => {
    setShowCreation(false);
    props.reset(false);
  };

  //pour le petit modal
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => {
    setShow(false);
    props.reset(false);
  };
  const handleShow = () => setShow(true);

  const [lotsCount, setLotsCount] = useState(1);
  const [inputList, setInputList] = useState([]);
  // const [dataUrl, setDataUrl] = useState();
  const [isloading, setIsLoading] = useState(true);

  var lotEnMemoire = mem.lotEnMemoire;  //attention, il faudra recharger après une modif du module recopier...
  var lesSousLotsEnMemoire = mem.lesSousLotsEnMemoire;

  
  async function InfosLot(lotTraceur) {
    let intLotTraceur = parseInt(lotTraceur,10)
    let infos = await intchaine.getInfosLot(intLotTraceur)
    return infos;
  }

  useEffect(() => {
    async function gererAffichage() {
      setIsLoading(true);
      await mem.calculerNoteEtClassement();
      let nomL = lotEnMemoire["numFournisseur"];
      let libelle = lotEnMemoire["libelle"];
      let hashIm = lotEnMemoire["image"];
      let descrLot = lotEnMemoire["descr"];
      let argLot = lotEnMemoire["arg"];

      var lotsTraceurs = [];
      var pourcentsTraceurs = [];
      var numFourns = [];
      var libelleFourns = [];
      var descrFourns = [];
      var pourcentsFourn = [];




      var dataUrl;

      var compteLot = 1;

      if (hashIm) {  //hashIm cad image...
        if (DEBUG) console.log("je vais appeler axios pour avoir l'image correspondant au lot");
        // const res = await axios.get("http://localhost:3008/download", {
        let res = null;
        try {
          res = await axios.get(
            // "http://" + mem.addressIPRemoteimages + ":3008/download",
            "https://" + mem.addressIPRemoteimages + ":3008/download",
            {
              responseType: "blob",
              params: { fichierImage: hashIm },
              timeout: 10000,
            }
          );
        } catch {
          alert("problème avec le serveur d'images");
        }
        if (DEBUG) console.log(res.data);
        dataUrl = URL.createObjectURL(res.data);
        if (DEBUG) console.log("j'ai appelé axios pour avoir l'image");
      }

      //on constitue la liste pour affichage en commençant par le lot
      var listetemp = [];
      listetemp = [
        ...listetemp,
        {
          id: compteLot,
          jsx: (
            <>
              <br />
              {hashIm && (
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  <img src={dataUrl} alt="produit" width={100} height={100} />{" "}
                </span>
              )}
              <br />

              <p>
                <span style={{ color: "blue" }}>Numéro de Lot: </span>
                {lotEnMemoire["numFournisseur"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Dénomination: </span>
                {lotEnMemoire["libelle"]}
                {/* <span style={{whiteSpace: "pre-wrap"}}>{lotEnMemoire["libelle"]}</span> */}
              </p>
              <p>
                <span style={{ color: "blue" }}>Fichier image: </span>
                {lotEnMemoire["image"]}
              </p>
              <p style={{whiteSpace: "pre-wrap" }}>
                <span style={{ color: "blue" }}>Description: </span>
                {lotEnMemoire["descr"]}
              </p>
              <p style={{whiteSpace: "pre-wrap" }}>
                <span style={{ color: "blue" }}>Argumentaire: </span>
                {"\n" + lotEnMemoire["arg"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Nombre d'articles distribués: </span>
                {lotEnMemoire["nbreArt"]}
              </p>              
              <p>
                <span style={{ color: "blue" }}>Pourcentage d'ingrédienst extérieurs: </span>
                {lotEnMemoire["pourcentExt"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Note: </span>
                {lotEnMemoire["note"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Classement: </span>
                {lotEnMemoire["classement"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Empreinte Carbone Ingrédients internes: </span>
                {lotEnMemoire["carbone"]}
              </p>
              <p>
                <span style={{ color: "blue" }}>Empreinte Carbone Totale: </span>
                {lotEnMemoire["carboneTot"]}
              </p>    
              <p>
                <span style={{ color: "blue" }}>Empreinte Carbone pertinente: </span>
                {lotEnMemoire["carbonePert"].toString()}
              </p>                           
              <p>
                <span style={{ color: "blue" }}>Date limite de consommation</span>
                {lotEnMemoire["DLC"]}
              </p>  

              <p>------------------------------------------------------------------------------------------</p>
              <br />
            </>
          ),
        },
      ];
      compteLot++;
      // setLotsCount(lotsCount + 1);

      //boucle sur les sous-lots
      for (var i = 0; i < lesSousLotsEnMemoire.length; i++) {
        var sousL = lesSousLotsEnMemoire[i];
        if (sousL["type"] == "traceur") {
          listetemp = [
            ...listetemp,
            {
              id: compteLot,
              jsx: (
                <>
                  <h4> SOUS-LOT TRACEUR</h4>
                  <p>
                    <span style={{ color: "blue" }}>Numero Traceur </span>
                    {sousL["numTraceur"]+" ("+ (await InfosLot(sousL["numTraceur"]))[2]+")"  }
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Pourcentage dans le contenu: </span>
                    {sousL["pourcent"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Empreinte carbone Totale: </span>
                    {(await InfosLot(sousL["numTraceur"]))[18]}
                  </p>  
                  <p>
                    <span style={{ color: "blue" }}>Empreinte carbone rajoutée: </span>
                    {sousL["carboneRaj"]}
                  </p>                                   
                  <p>
                    <span style={{ color: "blue" }}>Empreinte carbone pertinente: </span>
                    {((await InfosLot(sousL["numTraceur"]))[19]).toString()}
                  </p>  


                  <br />
                </>
              ),
            },
          ];
          compteLot++;
          // setLotsCount(lotsCount + 1);
        }
        if (sousL["type"] == "fournisseur") {
          listetemp = [
            ...listetemp,
            {
              id: compteLot,
              jsx: (
                <>
                  <h4> SOUS-LOT FOURNISSEUR</h4>
                  <p>
                    <span style={{ color: "blue" }}>
                      Numero de Lot chez fournisseur{" "}
                    </span>
                    {sousL["numFournisseur"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>dénomination: </span>
                    {sousL["libelle"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Fabricant: </span>
                    {sousL["nomFabricant"]}
                  </p>  
                  <p>
                    <span style={{ color: "blue" }}>Pays du Fabricant: </span>
                    {sousL["paysFabricant"]}
                  </p >                                    
                  <p style={{whiteSpace: "pre-wrap" }}>
                    <span style={{ color: "blue" }}>Description </span>
                    {sousL["descr"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Pourcentage dans le contenu: </span>
                    {sousL["pourcent"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Empreinte carbone: </span>
                    {sousL["carbone"]}
                  </p>
                  <p>
                    <span style={{ color: "blue" }}>Empreinte carbone rajoutée: </span>
                    {sousL["carboneRaj"]}
                  </p>    
                                
                  <br />
                </>
              ),
            },
          ];
          compteLot++;
          // setLotsCount(lotsCount + 1);
        }
      }
      // setLotsCount(lotsCount);
      setInputList(listetemp);
      setIsLoading(false);
    }
    gererAffichage();
  }, [lotEnMemoire, lesSousLotsEnMemoire]);


  
  async function creerLot() {
    setShowCreation(false);
    try {
      if (DEBUG) console.log("je vais creer le lot");
      await mem.goCreerLot();
      if (DEBUG) console.log("j'imprime: lot créé avec succès");
      setMsgModal("lot créé avec succès");
      setShow(true);
    } catch {
      if (DEBUG) console.log("il y a eu un pb??");
      setMsgModal("problème lors de la création du lot");
      setShow(true);
    }
    let nbrL = await intchaine.getLengthLots();
    if (DEBUG) console.log("Nombre de Lots: ", nbrL);
  }

  const liste = inputList.map((inp) => <div key={inp.id}>{inp.jsx}</div>);

  return (
    <>
      <Modal show={showCreation} onHide={handleCloseCreation} size="lg">
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              paddingLeft: "60px",
            }}
          >
            VERIFIEZ LES DONNEES DU LOT
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            paddingLeft: "60px",
            marginLeft: "50px",
            marginRight: "50px",
            borderStyle: "inset",
            borderWidth: "2px",
          }}
        >
          {isloading && (
            <ImSpinner3
              color="grey"
              icon="spinner"
              className="spinner"
              style={{ height: 100, width: 100 }}
            />
          )}
          {/* la liste des sous-lots */}
          {liste}
        </Modal.Body>
        <p>{" "}</p>
        <p className="ps-2" style={{ marginLeft: "50px", marginRight: "50px" }}>
          Pour creer le lot sur la blockchain, cliquez sur le bouton Creer Lot
          puis confirmer la transaction sur Metamask en cliquant sur le bouton
          Confirm en bas de la fenetre MetaMask à droite.
        </p>
        <Modal.Footer>
          <Button variant="secondary" onClick={creerLot}>
            Creer Lot
          </Button>
          <Button variant="secondary" onClick={handleCloseCreation}>
            Annuler
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show}>
        <Modal.Header closeButton>
          <Modal.Title>Création Lot</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
